'use strict';

var _ = require('lodash');

function GrowlController ($scope, SaturnService, $timeout) {
  var vm = $scope;

  vm.growls = [];

  vm.removeGrowl = function removeGrowl(index) {
    vm.growls.splice(index, 1);
  };

  SaturnService.removeGrowlById = function removeGrowlById(id) {
    _.remove(vm.growls, function(growl) {
      return growl.options.id === id;
    });
  }

  SaturnService.listen(function(evt, message, options) {
    // remove growls with duplicate ID's (if set)
    if(options.id) {
      _.remove(vm.growls, function(growl) {
        return growl.options.id === options.id;
      });
    }

    vm.growls.push({
      message: message,
      options: options
    });

    // To have the growl persist open, make time -1
    if (!options.time || options.time > 0) {
      vm.removeGrowlsTimeout = $timeout(function() {
        vm.growls.shift();
      }, options.time ? parseInt(options.time) : 2500 );
    }
  });

  SaturnService.listenRemove(function(evt, options) {
    if (!options) {
      vm.growls = []
      return
    }

    vm.growls = _.reject(vm.growls, {options: options});
  });
}

module.exports = GrowlController;



//////////////////
// WEBPACK FOOTER
// ./~/@skycatch/saturn-growl-booster/src/GrowlController.js
// module id = 767
// module chunks = 0